"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.DesignerCatalog = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var Design_1 = require("./Design");
var luxon_1 = require("luxon");
var DesignerApplicationConfiguration_1 = require("./DesignerApplicationConfiguration");
var DesignerCatalog = /** @class */ (function () {
    function DesignerCatalog() {
    }
    DesignerCatalog.isEmptyCatalog = function (designerCatalog) {
        return designerCatalog.id === '' && designerCatalog.availableCollections.length === 0;
    };
    DesignerCatalog.getDesignerPieceVariant = function (designerCatalog, productCollectionId, productId, pieceVariantId) {
        var productCollection = designerCatalog.availableCollections.find(function (c) { return c.id === productCollectionId; });
        var product = productCollection.products.find(function (p) { return p.id === productId; });
        var designerPieceVariant = product.pieceVariants.find(function (pv) { return pv.id === pieceVariantId; });
        return designerPieceVariant;
    };
    DesignerCatalog.getDesignerAccessoryVariant = function (designerCatalog, productCollectionId, productId, accessoryVariantId) {
        var productCollection = designerCatalog.availableCollections.find(function (c) { return c.id === productCollectionId; });
        var product = productCollection.products.find(function (p) { return p.id === productId; });
        var designerAccessoryVariant = product.accessoryVariants.find(function (av) { return av.id === accessoryVariantId; });
        return designerAccessoryVariant;
    };
    DesignerCatalog.getAllProducts = function (designerCatalog) {
        return designerCatalog.availableCollections.map(function (c) { return c.products; }).reduce(function (c1, c2) { return c1.concat(c2); });
    };
    DesignerCatalog.getAllWebshopCatalogReferencesFromPreviousCatalogProductsThatMatchFutureCatalogProducts = function (previousDesignerCatalog, futureDesignerCatalog) {
        var result = [];
        var futureDesignerCatalogProducts = DesignerCatalog.getAllProducts(futureDesignerCatalog);
        var _loop_1 = function (previousDesignerCatalogShopifyCatalogReference) {
            if (futureDesignerCatalogProducts.findIndex(function (futureProduct) {
                return futureProduct.id === previousDesignerCatalogShopifyCatalogReference.designerProductId;
            }) !== -1) {
                /* The future product is related to the previous product => The future product can get the previous webshop references. */
                result.push({
                    materialType: previousDesignerCatalogShopifyCatalogReference.materialType,
                    webshopProductId: previousDesignerCatalogShopifyCatalogReference.webshopProductId,
                    designerProductId: previousDesignerCatalogShopifyCatalogReference.designerProductId,
                    variants: []
                });
            }
        };
        for (var _i = 0, _a = previousDesignerCatalog.webshopCatalogReferences; _i < _a.length; _i++) {
            var previousDesignerCatalogShopifyCatalogReference = _a[_i];
            _loop_1(previousDesignerCatalogShopifyCatalogReference);
        }
        return result;
    };
    DesignerCatalog.getViewer3DEnvironment = function (designerCatalog) {
        return designerCatalog.designerApplicationConfiguration.viewer3DEnvironment;
    };
    DesignerCatalog.setDesignerThemeOverride = function (designerCatalog, theme) {
        designerCatalog.designerApplicationConfiguration.theme = theme;
    };
    DesignerCatalog.getDesignerTheme = function (designerCatalog) {
        return designerCatalog.designerApplicationConfiguration.theme;
    };
    DesignerCatalog.getDefaultLanguage = function (designerCatalog) {
        return designerCatalog.designerApplicationConfiguration.defaultLanguage;
    };
    DesignerCatalog.getDefaultPointOfView3D = function (designerCatalog, side) {
        if (side === void 0) { side = Design_1.Side.FRONT; }
        switch (side) {
            case Design_1.Side.FRONT:
                return designerCatalog.designerApplicationConfiguration.viewer3DEnvironment.defaultPointOfView3D;
            case Design_1.Side.BACK:
                return __assign(__assign({}, designerCatalog.designerApplicationConfiguration.viewer3DEnvironment.defaultPointOfView3D), { yaw: -designerCatalog.designerApplicationConfiguration.viewer3DEnvironment.defaultPointOfView3D.yaw });
            default:
                throw new core_common_domain_1.Exception("Unrecognisable side " + side);
        }
    };
    DesignerCatalog.emptyCatalog = {
        id: '',
        designerApplicationConfiguration: DesignerApplicationConfiguration_1.DesignerApplicationConfigurationBuilder.initialiseWithDefaults().build(),
        availableSymbolCollections: [],
        availableSymbols: [],
        availableFonts: [],
        availableAccessories: [],
        availablePieces: [],
        availableCollections: [],
        webshopCatalogReferences: [],
        published: luxon_1.DateTime.local()
    };
    return DesignerCatalog;
}());
exports.DesignerCatalog = DesignerCatalog;
